var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular
        .module('QMC.Tagebuch', [])
        .config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('journal', {
            url: '/journal?id',
            templateUrl: qmcBase + '/Journal/List',
            controller: 'TagebuchListController',
            controllerAs: 'vm',
            resolve: {
                data: [
                    () => {
                        console.log('Current State: Journal List');
                    }
                ]
            },
            params: {
                id: {
                    dynamic: true
                }
            }
        })
            .state('journalDetail', {
            url: '/journal/:id',
            templateUrl: qmcBase + '/Journal/Detail',
            controller: 'TagebuchDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [
                    () => {
                        console.log('Current State: Journal Detail');
                    }
                ]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Tagebuch;
    (function (Tagebuch) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Tagebuch.HttpProvider = HttpProvider;
    })(Tagebuch = QMC.Tagebuch || (QMC.Tagebuch = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Tagebuch')
        .config(['$httpProvider', QMC.Tagebuch.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Tagebuch;
    (function (Tagebuch) {
        let TagebuchService = class TagebuchService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Journal';
            }
            getJournalList() {
                return super.get(this.modulePath, {}, (data) => {
                    return data;
                });
            }
            getJournalAuthors(journalId) {
                const key = 'journalAuthors:' + journalId;
                return this.getCached(key, () => super.get(this.modulePath + '/' + journalId + '/Authors', {}, (data) => data), { ttlMs: 5 * 60 * 1000 }); // 5 minutes
            }
            getJournalEntry(journalEntryId) {
                return super.getItem(this.modulePath + '/Entry/Single/' + journalEntryId, {}, (data) => {
                    return data;
                });
            }
            getJournalEntryList(journalId, filter) {
                console.log('service filter', filter);
                return super.getPagination(this.modulePath + '/Entry/' + journalId, filter, (data) => {
                    return data;
                });
            }
            getJournalEntryParticipantList(entryId) {
                return super.get(this.modulePath + '/Entry/' + entryId + '/Participants', {}, (data) => {
                    return data;
                });
            }
            getJournalEntryWv(journalId) {
                var additionalParams = "";
                if (journalId !== null)
                    additionalParams = "?journalId=" + journalId;
                return super.getItem(this.modulePath + '/Entry/WvModel' + additionalParams, {}, (data) => {
                    return data;
                });
            }
            postJournalEntry(data) {
                return super.post(this.modulePath + '/Entry', data).then((data) => {
                    return data;
                });
            }
            postJournalEntryMultiple(data) {
                return super.post(this.modulePath + '/Entry/Multiple', data).then((data) => {
                    return data;
                });
            }
            putJournalEntry(id, data) {
                return super.put(this.modulePath + '/Entry/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteJournalEntry(id) {
                return super.delete(this.modulePath + '/Entry/' + id).then((data) => {
                    return data;
                });
            }
            postValidation(data) {
                return super.post(this.modulePath + '/Entry/WarningsAndErrors', data).then((data) => {
                    return data;
                });
            }
            getJournalParticipants(addEmptyItem = false) {
                return super.getItem("/Person/PeopleSelectionAssignment/TAGEBUCHBETEILIGTE", { addEmptyItem: addEmptyItem }, (data) => {
                    return data;
                });
            }
            getJournalRequiredFields() {
                return super.getItem(this.modulePath + "/RequiredFields", {}, (data) => {
                    return data;
                });
            }
            /***** SupportPlanTarget Template *****/
            getSupportPlanTargetTemplates(clientId) {
                return super.get('/SupportPlan/Template/' + clientId, {}, (data) => {
                    return data;
                });
            }
            getSupportPlanTargetTemplateItems(id) {
                return super.get('/SupportPlan/Template/item/' + id, {}, (data) => {
                    return data;
                });
            }
            /***** SupportPlanPhase *****/
            getSupportPlanActivePhase(supportPlanId) {
                return super.getItem('/SupportPlan/' + supportPlanId + '/ActivePhase/', {}, (data) => {
                    return data;
                });
            }
        };
        TagebuchService = __decorate([
            QMC.Service('QMC.Tagebuch', 'TagebuchService'),
            QMC.Inject('$http', '$q')
        ], TagebuchService);
        Tagebuch.TagebuchService = TagebuchService;
    })(Tagebuch = QMC.Tagebuch || (QMC.Tagebuch = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Tagebuch;
    (function (Tagebuch) {
        // Constants
        const COMMENT_TYPE_WARNING_ID = '7d1d5043-fe48-4b93-be38-c2bfd8e41d08';
        const COMMENT_TYPE_NORMAL_ID = 'b22fa7fc-8d14-4ae1-8483-729c5df12c07';
        const LINE_HEIGHT_1PT_REGEX = /line-height:\s*1pt;/gi;
        const DEFAULT_PAGE_SIZE = 10;
        const DEFAULT_FILTER_DAYS_BACK = 14;
        let TagebuchListController = class TagebuchListController {
            /**
             * Creates an instance of TagebuchListController.
             */
            constructor($location, tagebuchService, $qui, clientService, $state, $scope, lng, permissionService, userService, markItemService, $sce, $stateParams, stammdatenService, udfService, $q, $timeout) {
                this.$location = $location;
                this.tagebuchService = tagebuchService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.markItemService = markItemService;
                this.$sce = $sce;
                this.$stateParams = $stateParams;
                this.stammdatenService = stammdatenService;
                this.udfService = udfService;
                this.$q = $q;
                this.$timeout = $timeout;
                this.udfs = [];
                this.newFormOpen = false;
                this.formState = "edit";
                // Date and time management
                this.useCurrentDate = false;
                // Participants
                this.participantsList = [];
                this.maps = {
                    livingArea: [],
                    priority: [],
                    clients: [],
                    sorting: [],
                    journal: [],
                    markings: []
                };
                // Loading states
                this.loading = false;
                this.loadingWv = false;
                this.loadingMore = false;
                this.saveLoading = false;
                this.page = 0;
                this.pageSize = DEFAULT_PAGE_SIZE;
                this.listPage = 0;
                this.lastPage = false;
                this.alreadyLoad = false;
                this.scrollInit = false;
                // Filter
                this.activeSetFilter = false;
                this.filterDefaults = {
                    filterDateFrom: null,
                    filterDateTo: null,
                    filterDateToDisplay: 1,
                    filterLivingAreaWvId: [],
                    filterPriorityWvId: [],
                    filterParticipantId: null,
                    filterComment: null,
                    filterAuthorId: [],
                    markings: [],
                    commentsDescending: false
                };
                // Permissions
                this.forbidden = false;
                this.new = false;
                this.modify = false;
                this.delete = false;
                this.newParticipant = false;
                this.modifyParticipant = false;
                this.allowExport = false;
                // Support plan
                this.supportPlanForm = [];
                this.newEntrySupportPlan = false;
                // Warning and validation
                this.enableWarningReason = false;
                this.elaborativeWarning = false;
                this.elaborativeWarningData = {};
                this.isEntryModWarning = false;
                this.validation = {
                    errors: [],
                    warnings: [],
                    loading: false
                };
                this.afterValidationAction = "";
                /** Incremented on each validation request; stale HTTP responses are ignored (rapid consecutive saves). */
                this.validationGeneration = 0;
                this.warning = [];
                this.text = [];
                // Marking
                this.markNewEntry = false;
                this.quickMessage = {
                    subject: '',
                    message: '',
                    open: false
                };
                // Write protection
                this.writeProtection = {
                    authorOnly: false,
                    isActive: false,
                    allowedDaysIntoPast: 0,
                    hours: 0,
                    minutes: 0
                };
                // UI state
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.createSummernote = null;
                this.smartAction = new QMC.Common.SmartAction(this.permissionService, this.userService, this.clientService, this.lng, this.$scope);
                this.newFormCacheName = 'JournalNewCache-' + $("#session").data().personId;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    this.events();
                    $(".help-block").parent("div").attr("style", "");
                });
                if (document.getElementById("permissions").getAttribute("journal").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                this.promptOptions = {
                    title: this.lng.translate(20001007, "Tagebuch"),
                    yesNo: true,
                    icon: "qm-icon-note_pinned",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.promptOptionsCache = {
                    title: this.lng.translate(20001007, "Tagebuch"),
                    yesNo: true,
                    icon: "qm-icon-arrow_circle",
                    text: this.lng.translate(20000228, 'Es gibt nicht gespeicherte Änderungen, wollen Sie diese wiederherstellen?'),
                };
                //ObjectType: TagebuchItem
                this.permissionService.getPermissionsByObjectTypes([370002, 370000]).then((data) => {
                    this.tagebuchService.getJournalRequiredFields().then((rf) => {
                        this.delete = data[0].delete;
                        this.new = data[0].new;
                        this.modify = data[0].modify;
                        // used to listen to 370004, that changed according to DAA-3725 where it was decided that participants belong to the base permission
                        this.newParticipant = data[0].new;
                        this.modifyParticipant = data[0].modify;
                        this.requiredFields = rf;
                        this.allowExport = false;
                    });
                });
                this.dateManual = new Date();
                this.timeManual = new Date();
                this.filterDefaults.filterDateFrom = moment().subtract(DEFAULT_FILTER_DAYS_BACK, 'd').toDate();
                this.filterDefaults.filterDateTo = new Date();
                this.filter = angular.copy(this.filterDefaults);
                this.form = this.initForm();
                this.selectLastUsedJournal();
                if ($stateParams.id)
                    this.journalId = $stateParams.id;
                this.getUserSettings(); //Aufruf von init im Callback
                this.getJournals();
                this.stammdatenService.getParticipantsSelectionAssignment('TAGEBUCHBETEILIGTE', true).then((data) => {
                    this.possibleParticipants = data;
                    const values = data.map(x => ({ value: x.objectId, text: this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.personNumber), subText: x.institute, group: x.objectTypeCaption }));
                    values.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                    values.sort((a, b) => (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0));
                    this.list = values;
                });
                this.maps.sorting = [
                    { value: '0', text: this.lng.translate(20017025, 'nach Datum der letzten Änderung') },
                    { value: '1', text: `${this.lng.translate(20017025, 'nach Datum der letzten Änderung')} (${this.lng.translate(20000307, 'absteigend')})` },
                    { value: '2', text: this.lng.translate(20017026, 'nach Erstelldatum') },
                    { value: '3', text: `${this.lng.translate(20017026, 'nach Erstelldatum')} (${this.lng.translate(20000307, 'absteigend')})` },
                    { value: '4', text: this.lng.translate(20017027, 'nach manuellem Datum') },
                    { value: '5', text: `${this.lng.translate(20017027, 'nach manuellem Datum')} (${this.lng.translate(20000307, 'absteigend')})` },
                ];
                this.alreadyLoad = false;
                this.setFilterFromLocalStorage();
                this.smartActionObject = {
                    smartActions: this.smartAction,
                    clients: this.list,
                    participants: this.participantsList
                };
                udfService.getUserDefinedFields(370002).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            /**
             * get the filter storage key for the current journal
             *
             * @private
             * @returns {string}
             *
             * @memberOf TagebuchListController
             */
            getFilterStorageKey() {
                return `${QMC.Common.LocalStorageConstants.JOURNAL_FILTER}_${this.journalId}`;
            }
            /**
             * init the form with default values
             *
             * @private
             * @returns {IJournalEntryCreate}
             *
             * @memberOf TagebuchListController
             */
            initForm() {
                return {
                    id: null,
                    comment: "",
                    commentTypeWvId: null,
                    journalId: this.journalId,
                    livingAreaId: null,
                    priorityId: null,
                    objectId: null,
                    parentEntryId: null,
                    participants: null,
                    dateManual: null
                };
            }
            /////////////// DISPLAY LOGIC ///////////////
            trustAsHtml(html) {
                return this.$sce.trustAsHtml(html);
            }
            /**
             * Map Wertvolle Liste to Select Items
             */
            mapWvListToSelectItems(wvList) {
                return (wvList === null || wvList === void 0 ? void 0 : wvList.map(x => ({ value: x.objectId, text: x.name }))) || [];
            }
            /**
             * register view events
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            events() {
                $(document).scroll(() => {
                    if (!this.alreadyLoad && !this.loading && this.scrollInit && !this.lastPage && ($(window).scrollTop() >= ($(document).height() - $(window).height()) * 0.7)) {
                        this.alreadyLoad = true;
                        this.changePage();
                    }
                });
                this.$scope.$watch('vm.journalId', (newValue, oldValue) => {
                    if (newValue !== oldValue)
                        this.selectedJournalChanged();
                });
                this.$scope.$watch('vm.form', (newValue, oldValue) => {
                    if (this.newFormOpen && JSON.stringify(newValue) !== JSON.stringify(oldValue))
                        this.setNewFormCache();
                }, true);
                this.$scope.$watch('vm.participantsList', (newValue, oldValue) => {
                    if (this.newFormOpen && newValue !== oldValue) {
                        this.setNewFormCache();
                        this.smartActionObject.participants = this.participantsList;
                    }
                });
                this.$scope.$watch('vm.list', (newValue, oldValue) => {
                    if (this.newFormOpen && newValue !== oldValue) {
                        this.smartActionObject.clients = this.list;
                    }
                });
                this.$scope.$watch('vm.useCurrentDate', (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        this.setNewFormCache();
                        QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.JOURNAL_USE_CURRENT_DATE, String(newValue));
                    }
                });
                this.$scope.$watch('vm.dateManual', (newValue, oldValue) => {
                    if (this.dateManual && newValue !== oldValue)
                        this.setNewFormCache();
                });
                this.$scope.$watch('vm.timeManual', (newValue, oldValue) => {
                    if (this.dateManual && newValue !== oldValue)
                        this.setNewFormCache();
                });
                this.$scope.$watch('vm.markNewEntry', (newValue, oldValue) => {
                    if (newValue !== oldValue)
                        this.setNewFormCache();
                });
                this.$scope.$watch('vm.newEntrySupportPlan', (newValue, oldValue) => {
                    if (newValue !== oldValue)
                        this.setNewFormCache();
                });
                this.$scope.$watch('vm.supportPlanForm', (newValue, oldValue) => {
                    if (newValue !== oldValue)
                        this.setNewFormCache();
                }, true);
                $('#add-journal-entry').bind('style-change', () => {
                    this.newFormOpen = $('#add-journal-entry').css('display') !== ' none';
                });
                setTimeout(() => {
                    this.$qui.functionWaiter('createSummernote', this);
                }, 200);
            }
            newButtonClick() {
                if (this.newFormOpen) {
                    const cache = this.getNewFormCache();
                    // only offer cache of there is anything of interest included
                    if (cache && cache.journalId === this.journalId && ((cache.comment && cache.comment.length > 0) || cache.livingAreaId || cache.priorityId || (cache.participants && cache.participants.length > 0))) {
                        QMC.Common.Utilities.confirm(this.promptOptionsCache, (dataCache) => {
                            if (dataCache) {
                                this.form = cache;
                                this.participantsList = cache.participants;
                                if (cache.dateManual) {
                                    this.useCurrentDate = false;
                                    this.dateManual = cache.dateManual;
                                    this.timeManual = cache.dateManual;
                                }
                                if (cache.mark)
                                    this.markNewEntry = true;
                                if (cache.isSupportPlan) {
                                    this.newEntrySupportPlan = true;
                                    setTimeout(() => {
                                        this.supportPlanForm = cache.supportPlanForm;
                                    }, 50);
                                }
                            }
                            else {
                                this.form = this.initForm();
                            }
                        }, '#promptCache');
                    }
                    else {
                        this.clearNewFormCache();
                        this.form = this.initForm();
                        this.supportPlanForm = [];
                        this.newEntrySupportPlan = false;
                    }
                }
            }
            setNewFormCache() {
                var _a;
                if (this.form && (!this.form.commentTypeWvId || this.form.commentTypeWvId === QMC.Common.Constants.GUID_EMPTY)) {
                    this.form.participants = this.participantsList;
                    if (!this.useCurrentDate) {
                        this.form.dateManual = this.$qui.addTimeToDate(this.dateManual, this.timeManual);
                    }
                    else {
                        this.form.dateManual = null;
                    }
                    this.form.mark = this.markNewEntry;
                    this.form.journalId = this.journalId;
                    const form = angular.copy(this.form);
                    form.isSupportPlan = this.newEntrySupportPlan;
                    if (form.isSupportPlan)
                        form.supportPlanForm = this.supportPlanForm;
                    form.comment = (_a = form.comment) === null || _a === void 0 ? void 0 : _a.replace(/<img[^>]*>/g, ""); // remove images from cache
                    QMC.Common.personalLocalStorage.setItem(this.newFormCacheName, JSON.stringify(form));
                }
            }
            getNewFormCache() {
                if (this.hasNewFormCache()) {
                    const obj = JSON.parse(QMC.Common.personalLocalStorage.getItem(this.newFormCacheName));
                    if (obj.dateManual)
                        obj.dateManual = this.$qui.createDateFromString(obj.dateManual);
                    return obj;
                }
                return null;
            }
            hasNewFormCache() {
                const cache = QMC.Common.personalLocalStorage.getItem(this.newFormCacheName);
                return (cache && cache.length > 0);
            }
            clearNewFormCache() {
                QMC.Common.personalLocalStorage.removeItem(this.newFormCacheName);
            }
            /**
             * save the last selected journal, get the new list of journals
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            selectedJournalChanged() {
                if (this.lastJournal === this.journalId)
                    return;
                this.lastJournal = this.journalId;
                QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.JOURNAL_LAST_SELECTED_ID, this.journalId);
                this.page = 0;
                this.journalEntries = [];
                this.loadJournalAuthors();
                this.getWvList(this.journalId);
                this.getJournalPerms();
                this.setFilterFromLocalStorage();
                this.loadJournalAuthors().then(() => {
                    this.getJournalEntries();
                });
                this.$state.go('journal', { id: this.journalId }, { reload: false });
            }
            getJournalPerms() {
                this.permissionService.getPermissionsForDataset(this.journalId, 370000).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.allowExport = data[0].print;
                });
            }
            /**
             * select the last used journal entry
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            selectLastUsedJournal() {
                const lastJournalId = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.JOURNAL_LAST_SELECTED_ID);
                if (lastJournalId) {
                    this.journalId = lastJournalId;
                }
            }
            /**
             * Count the entry warnings
             */
            countEntryWarnings(comments) {
                const warningText = this.lng.translate(20002017, "Warnung");
                const warningsText = this.lng.translate(20000110, "Warnungen");
                const count = comments.filter(c => c.commentType === warningText).length;
                const text = count > 1 ? ` ${warningsText}` : ` ${warningText}`;
                return count + text;
            }
            countSubWarnings(subs) {
                return subs.filter(item => item.commentTypeWvId === COMMENT_TYPE_WARNING_ID).length;
            }
            /**
             * Count the number of comments for a journal entry
             */
            countEntryComments(comments) {
                const commentText = this.lng.translate(20000287, "Kommentar");
                const commentsText = this.lng.translate(20017041, "Kommentare");
                const count = comments.filter(c => c.commentType === commentText).length;
                let icon;
                let text;
                let displayCount = count;
                if (count === 0) {
                    icon = "fa-commenting-o";
                    text = commentsText;
                    displayCount = "";
                }
                else if (count === 1) {
                    icon = "fa-comment-o";
                    text = commentText;
                }
                else {
                    icon = "fa-comments-o";
                    text = commentsText;
                }
                return this.$sce.trustAsHtml(`<i class="fa ${icon}"></i> ${displayCount} ${text}`);
            }
            /**
             * Toggle the visibility of comments
             */
            toggleCommentVisiblity(id) {
                $(`#${id}`).slideToggle();
                this.$qui.scopeApply(this.$scope);
            }
            areSubsHidden(id) {
                return $(`#${id}`).css('display') === 'none';
            }
            /**
             * get the journal entry list
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            init() {
                const stateId = this.$state.params.id;
                if (stateId !== undefined && stateId !== null) {
                    this.journalId = stateId;
                    this.getWvList(this.journalId);
                    this.getJournalEntries();
                }
            }
            getData() {
                this.getWvList(this.journalId);
                this.getJournalPerms();
                this.loadJournalAuthors().then(() => {
                    this.getJournalEntries();
                });
            }
            loadJournalAuthors(forceRefresh = false) {
                if (!this.journalId && !forceRefresh) {
                    this.currentJournalAuthors = [];
                    return this.$q.resolve();
                }
                return this.tagebuchService.getJournalAuthors(this.journalId).then((data) => {
                    var _a, _b, _c, _d;
                    this.currentJournalAuthors = data
                        .map(x => ({
                        value: x.userId,
                        text: this.$qui.createPersonDisplay(x.name, x.firstName, null, null) || x.name || ''
                    }))
                        .sort((a, b) => a.text.toLocaleLowerCase().localeCompare(b.text.toLocaleLowerCase()));
                    const validAuthorIdLookup = {};
                    for (const author of this.currentJournalAuthors) {
                        const validId = (_a = author.value) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase();
                        if (validId) {
                            validAuthorIdLookup[validId] = true;
                        }
                    }
                    const previousLength = (_c = (_b = this.filter.filterAuthorId) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
                    this.filter.filterAuthorId = ((_d = this.filter.filterAuthorId) !== null && _d !== void 0 ? _d : []).filter(id => !!validAuthorIdLookup[id === null || id === void 0 ? void 0 : id.toString().toLowerCase()]);
                    if (this.filter.filterAuthorId.length !== previousLength) {
                        this.setActiveSetFilter();
                        const filterToSave = angular.copy(this.filter);
                        delete filterToSave.filterDateFrom;
                        delete filterToSave.filterDateTo;
                        QMC.Common.personalLocalStorage.setItem(this.getFilterStorageKey(), JSON.stringify(filterToSave));
                    }
                });
            }
            /**
             * Check the type of an entry
             */
            checkEntryType(isWarning) {
                const entryTypeName = isWarning ? 'Warnung' : 'Kommentar';
                if (!this.wvs.entryTypeWvList)
                    return undefined;
                for (let i = 0; i < this.wvs.entryTypeWvList.length; i++) {
                    if (this.wvs.entryTypeWvList[i].name === entryTypeName) {
                        return this.wvs.entryTypeWvList[i].id;
                    }
                }
                return undefined;
            }
            setActiveSetFilter() {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                const hasDateFilter = !moment(this.filter.filterDateFrom).isSame(this.filterDefaults.filterDateFrom, 'date') ||
                    !moment(this.filter.filterDateTo).isSame(this.filterDefaults.filterDateTo, 'date');
                const hasArrayFilter = ((_b = (_a = this.filter.filterPriorityWvId) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 ||
                    ((_d = (_c = this.filter.filterLivingAreaWvId) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0 ||
                    ((_f = (_e = this.filter.filterAuthorId) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0 ||
                    ((_h = (_g = this.filter.markings) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 0) > 0;
                const hasOtherFilter = ((_k = (_j = this.filter.filterComment) === null || _j === void 0 ? void 0 : _j.length) !== null && _k !== void 0 ? _k : 0) > 0 ||
                    this.filter.filterParticipantId !== null ||
                    this.filter.commentsDescending;
                this.activeSetFilter = hasDateFilter || hasArrayFilter || hasOtherFilter;
            }
            /**
             * Set the filter
             */
            setFilter() {
                this.activeSetFilter = false;
                this.setActiveSetFilter();
                // Update query parameters if dates differ from default
                this.updateDateQueryParams();
                // Save entire filter object as one item with journalId prefix
                const filterToSave = angular.copy(this.filter);
                delete filterToSave.filterDateFrom;
                delete filterToSave.filterDateTo;
                QMC.Common.personalLocalStorage.setItem(this.getFilterStorageKey(), JSON.stringify(filterToSave));
                this.getJournalEntries();
            }
            /**
             * Initialize date filter from query parameters or use default (last 2 weeks)
             * @private
             */
            initializeDateFilter() {
                // Always initialize with default (last 2 weeks)
                this.filter.filterDateFrom = moment().subtract(DEFAULT_FILTER_DAYS_BACK, 'd').toDate();
                this.filter.filterDateTo = new Date();
                // Try to read from query parameters
                const dateFromParam = this.$location.search().dateFrom;
                const dateToParam = this.$location.search().dateTo;
                if (dateFromParam) {
                    const parsedDateFrom = moment(dateFromParam, 'YYYY-MM-DD').toDate();
                    if (parsedDateFrom && !isNaN(parsedDateFrom.getTime())) {
                        this.filter.filterDateFrom = parsedDateFrom;
                    }
                }
                if (dateToParam) {
                    const parsedDateTo = moment(dateToParam, 'YYYY-MM-DD').toDate();
                    if (parsedDateTo && !isNaN(parsedDateTo.getTime())) {
                        this.filter.filterDateTo = parsedDateTo;
                    }
                }
            }
            /**
             * Update URL query parameters if dates differ from default
             * @private
             */
            updateDateQueryParams() {
                const defaultDateFrom = moment().subtract(DEFAULT_FILTER_DAYS_BACK, 'd').startOf('day');
                const defaultDateTo = moment().endOf('day');
                const currentDateFrom = moment(this.filter.filterDateFrom).startOf('day');
                const currentDateTo = moment(this.filter.filterDateTo).endOf('day');
                const datesDiffer = !currentDateFrom.isSame(defaultDateFrom, 'day') ||
                    !currentDateTo.isSame(defaultDateTo, 'day');
                // Get current search params to preserve other parameters
                const currentSearch = this.$location.search();
                if (datesDiffer) {
                    // Set query parameters
                    currentSearch.dateFrom = moment(this.filter.filterDateFrom).format('YYYY-MM-DD');
                    currentSearch.dateTo = moment(this.filter.filterDateTo).format('YYYY-MM-DD');
                }
                else {
                    // Remove query parameters if they match default
                    delete currentSearch.dateFrom;
                    delete currentSearch.dateTo;
                }
                // Apply all search parameters at once
                this.$location.search(currentSearch);
            }
            /**
             * set the filter from the localStorage
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            setFilterFromLocalStorage() {
                // Initialize date filter from query params or defaults (always, not from localStorage)
                this.initializeDateFilter();
                const savedFilter = QMC.Common.personalLocalStorage.getItem(this.getFilterStorageKey());
                if (savedFilter) {
                    try {
                        const parsedFilter = JSON.parse(savedFilter);
                        // Merge saved filter with current filter, but exclude date fields (they come from query params or defaults)
                        this.filter = {
                            filterDateFrom: this.filter.filterDateFrom,
                            filterDateTo: this.filter.filterDateTo,
                            filterDateToDisplay: parsedFilter.filterDateToDisplay || this.filter.filterDateToDisplay,
                            filterLivingAreaWvId: parsedFilter.filterLivingAreaWvId || this.filter.filterLivingAreaWvId,
                            filterPriorityWvId: parsedFilter.filterPriorityWvId || this.filter.filterPriorityWvId,
                            filterParticipantId: parsedFilter.filterParticipantId || this.filter.filterParticipantId,
                            filterComment: parsedFilter.filterComment || this.filter.filterComment,
                            filterAuthorId: parsedFilter.filterAuthorId || this.filter.filterAuthorId,
                            markings: parsedFilter.markings || this.filter.markings,
                            commentsDescending: parsedFilter.commentsDescending || this.filter.commentsDescending
                        };
                    }
                    catch (error) {
                        // If parsing fails, keep default filter values (dates already initialized)
                        this.filter = {
                            ...angular.copy(this.filterDefaults),
                            filterDateFrom: this.filter.filterDateFrom,
                            filterDateTo: this.filter.filterDateTo
                        };
                    }
                }
                else {
                    // No saved filter, use defaults (dates already initialized)
                    this.filter = {
                        ...angular.copy(this.filterDefaults),
                        filterDateFrom: this.filter.filterDateFrom,
                        filterDateTo: this.filter.filterDateTo
                    };
                }
                // Update query parameters if dates differ from default
                this.updateDateQueryParams();
                this.setActiveSetFilter();
            }
            /**
             * Reset the filter
             */
            resetFilter() {
                this.filter = angular.copy(this.filterDefaults);
                // Reset dates to default (last 2 weeks) - don't read from query params
                this.filter.filterDateFrom = moment().subtract(DEFAULT_FILTER_DAYS_BACK, 'd').toDate();
                this.filter.filterDateTo = new Date();
                // Remove the entire filter from localStorage with journalId prefix
                QMC.Common.personalLocalStorage.removeItem(this.getFilterStorageKey());
                // Remove date query parameters since we're resetting to default
                const currentSearch = this.$location.search();
                delete currentSearch.dateFrom;
                delete currentSearch.dateTo;
                this.$location.search(currentSearch);
                this.setActiveSetFilter();
            }
            strip(html) {
                var _a;
                if (!html)
                    return "";
                const textEl = document.createElement("div");
                textEl.innerHTML = html;
                return ((_a = textEl.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || "";
            }
            /**
             * Check if a GUID value is empty
             * @private
             */
            isEmptyGuid(value) {
                return !value || value === QMC.Common.Constants.GUID_EMPTY;
            }
            /**
             * Sort subEntries by date
             * @private
             */
            sortSubEntries(subEntries) {
                if (!subEntries || subEntries.length === 0)
                    return;
                subEntries.forEach((sub) => {
                    sub.date = this.$qui.createDateFromString(sub.date);
                });
                subEntries.sort((a, b) => {
                    if (!a.date || !b.date)
                        return 0;
                    const comparison = a.date.getTime() - b.date.getTime();
                    return this.filter.commentsDescending ? -comparison : comparison;
                });
            }
            /**
             * Compare two entries based on FilterDateToDisplay (same logic as server)
             * Returns: negative if a should come before b, positive if after, 0 if equal
             * @private
             */
            compareEntries(a, b) {
                if (!a || !b)
                    return 0;
                // Get sort dates based on FilterDateToDisplay
                let dateA = null;
                let dateB = null;
                const isDescending = this.filter.filterDateToDisplay === 1 ||
                    this.filter.filterDateToDisplay === 3 ||
                    this.filter.filterDateToDisplay === 5;
                switch (this.filter.filterDateToDisplay) {
                    case 0:
                    case 1: // Last update
                        dateA = a.dateLastUpdate ? this.$qui.createDateFromString(a.dateLastUpdate) : (a.date ? this.$qui.createDateFromString(a.date) : null);
                        dateB = b.dateLastUpdate ? this.$qui.createDateFromString(b.dateLastUpdate) : (b.date ? this.$qui.createDateFromString(b.date) : null);
                        break;
                    case 2:
                    case 3: // Create date
                        dateA = a.date ? this.$qui.createDateFromString(a.date) : null;
                        dateB = b.date ? this.$qui.createDateFromString(b.date) : null;
                        break;
                    case 4:
                    case 5: // Manual date
                        dateA = a.dateManual ? this.$qui.createDateFromString(a.dateManual) : (a.date ? this.$qui.createDateFromString(a.date) : null);
                        dateB = b.dateManual ? this.$qui.createDateFromString(b.dateManual) : (b.date ? this.$qui.createDateFromString(b.date) : null);
                        break;
                    default:
                        dateA = a.dateLastUpdate ? this.$qui.createDateFromString(a.dateLastUpdate) : (a.date ? this.$qui.createDateFromString(a.date) : null);
                        dateB = b.dateLastUpdate ? this.$qui.createDateFromString(b.dateLastUpdate) : (b.date ? this.$qui.createDateFromString(b.date) : null);
                }
                if (!dateA && !dateB)
                    return 0;
                if (!dateA)
                    return 1;
                if (!dateB)
                    return -1;
                const comparison = dateA.getTime() - dateB.getTime();
                return isDescending ? -comparison : comparison;
            }
            /**
             * Find insertion index for new entry to maintain server sort order
             * @private
             */
            findInsertionIndex(newEntry) {
                if (!this.journalEntries || this.journalEntries.length === 0)
                    return 0;
                // Binary search for insertion point
                let left = 0, right = this.journalEntries.length;
                while (left < right) {
                    const mid = Math.floor((left + right) / 2);
                    if (this.compareEntries(newEntry, this.journalEntries[mid]) < 0) {
                        right = mid;
                    }
                    else {
                        left = mid + 1;
                    }
                }
                return left;
            }
            /**
             * Set isEditable flag for entry and all subEntries
             * @private
             */
            setEditableFlags(entry) {
                entry.isEditable = this.checkIfEditable(entry);
                if (entry.subEntries) {
                    for (let i = 0; i < entry.subEntries.length; i++) {
                        const subEntry = entry.subEntries[i];
                        subEntry.isEditable = this.checkIfEditable(subEntry);
                    }
                }
            }
            /**
             * Process journal entries: fix line-height, sort subEntries
             * @private
             */
            processJournalEntries(entries) {
                entries.forEach((entry) => {
                    entry.comment = entry.comment.replace(LINE_HEIGHT_1PT_REGEX, '');
                    if (entry.subEntries) {
                        this.sortSubEntries(entry.subEntries);
                    }
                });
            }
            /**
             * Create filter object for journal entry list requests
             * @private
             */
            createJournalFilter(page = 0, pageSize = this.pageSize, dateFrom, dateTo) {
                return {
                    FilterDateFrom: dateFrom || this.filter.filterDateFrom,
                    FilterDateTo: dateTo || this.filter.filterDateTo,
                    FilterDateToDisplay: this.filter.filterDateToDisplay,
                    FilterLivingAreaWvId: this.filter.filterLivingAreaWvId,
                    FilterPriorityWvId: this.filter.filterPriorityWvId,
                    FilterParticipantId: this.filter.filterParticipantId,
                    FilterComment: this.filter.filterComment,
                    FilterAuthorId: this.filter.filterAuthorId,
                    Markings: this.filter.markings,
                    Page: page,
                    PageSize: pageSize
                };
            }
            disableNewEntrySave() {
                if (this.newEntrySupportPlan) {
                    if (!this.supportPlanForm || this.supportPlanForm.length === 0)
                        return true;
                    return this.supportPlanForm.some(form => !form.valid);
                }
                if (!this.requiredFields)
                    return true;
                return (this.requiredFields.participants && (!this.participantsList || this.participantsList.length === 0)) ||
                    (this.requiredFields.comment && this.strip(this.form.comment).length === 0) ||
                    (this.requiredFields.priorityId && this.isEmptyGuid(this.form.priorityId)) ||
                    (this.requiredFields.livingAreaId && this.isEmptyGuid(this.form.livingAreaId));
            }
            disableModEntrySave() {
                var _a;
                if (!this.updateForm || !this.checkIfEditable(this.updateEntry))
                    return true;
                if ((_a = this.updateForm.supportPlanForm) === null || _a === void 0 ? void 0 : _a[0]) {
                    return !this.updateForm.supportPlanForm[0].valid;
                }
                if (this.udfs.some(x => !x.isValid))
                    return true;
                if (!this.requiredFields)
                    return true;
                if (this.updateForm.isSub) {
                    return this.requiredFields.comment && this.strip(this.updateForm.comment).length === 0;
                }
                return (this.requiredFields.participants && (!this.updateForm.participants || this.updateForm.participants.length === 0)) ||
                    (this.requiredFields.comment && this.strip(this.updateForm.comment).length === 0) ||
                    (this.requiredFields.priorityId && this.isEmptyGuid(this.updateForm.priorityId)) ||
                    (this.requiredFields.livingAreaId && this.isEmptyGuid(this.updateForm.livingAreaId)) ||
                    !this.updateForm.dateManual || !this.updateForm.timeManual;
            }
            getEntryActionTitle(entry) {
                return this.modify && this.checkIfEditable(entry)
                    ? this.lng.translate(20000044, 'Bearbeiten')
                    : this.lng.translate(20000141, 'Ansehen');
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the client list
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            getClientList() {
                return this.list;
            }
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            getWvList(journalId) {
                if (!journalId) {
                    this.wvs = {};
                    this.maps.livingArea = [];
                    this.maps.priority = [];
                    this.maps.clients = [];
                    this.maps.markings = [];
                    return;
                }
                ;
                //if no journallist loaded skip loading of wv since we need it to determine if the wvs should be constrained
                if (!this.journalList || this.journalList.length === 0) {
                    setTimeout(() => { this.getWvList(journalId); }, 500);
                    return;
                }
                for (const item of this.journalList) {
                    if (item.objectId === journalId) {
                        if (!item.limitLivingAreas)
                            journalId = undefined;
                        break;
                    }
                }
                this.loadingWv = true;
                this.tagebuchService.getJournalEntryWv(journalId).then((data) => {
                    if (!data.livingAreaWvList.some(x => !x.objectId))
                        data.livingAreaWvList.unshift({
                            id: null,
                            objectId: null,
                            name: "",
                            isFix: true,
                            value: 0
                        });
                    this.wvs = data;
                    this.maps.priority = this.wvs.priorityWvList.map(x => ({ value: x.objectId, text: x.name }));
                    this.maps.livingArea = this.wvs.livingAreaWvList.map(x => ({ value: x.objectId, text: x.name }));
                    this.maps.markings = this.wvs.markingsWvList.map(x => ({ value: x.objectId, text: x.name }));
                    this.loadingWv = false;
                });
            }
            /**
             * Post a new journal entry
             */
            postEntry() {
                if (this.saveLoading || this.validation.loading) {
                    return;
                }
                if (this.disableNewEntrySave()) {
                    return;
                }
                this.saveLoading = true;
                console.log("postEntry");
                if (this.journalId === undefined) {
                    this.journalId = this.journalList[0].objectId;
                }
                this.form.journalId = this.journalId;
                this.form.parentEntryId = null;
                this.form.commentTypeWvId = null;
                if (!this.useCurrentDate) {
                    this.setManualDateWithTime();
                }
                // Participants are already set from participantsList
                this.form.participants = this.participantsList;
                this.afterValidationAction = "postEntryPost";
                this.validateJournalEntry({
                    date: this.useCurrentDate ? new Date() : this.form.dateManual,
                    creationTimeStamp: new Date(),
                    id: null,
                    authorId: null
                });
                this.smartAction.resetSmartAction();
            }
            postEntryPost() {
                this.saveLoading = true;
                const formArray = [];
                if (this.newEntrySupportPlan) {
                    for (const sform of this.supportPlanForm) {
                        formArray.push({
                            dateManual: this.useCurrentDate ? undefined : this.$qui.addTimeToDate(this.dateManual, this.timeManual),
                            journalId: this.form.journalId,
                            comment: sform.comment,
                            livingAreaId: sform.livingAreaId,
                            participants: [sform.clientId],
                            supportPlan: {
                                personId: sform.clientId,
                                supportPlanId: sform.supportPlanId,
                                templateId: sform.templateId,
                                templateItemId: sform.templateItemId
                            }
                        });
                    }
                }
                else {
                    formArray.push(this.form);
                }
                this.tagebuchService.postJournalEntryMultiple(formArray)
                    .then((data) => {
                    // Determine the date of the created entry
                    const entryDate = this.useCurrentDate ? new Date() : this.$qui.addTimeToDate(this.dateManual, this.timeManual);
                    this.loadJournalAuthors(true);
                    // Load entries for the specific day and merge them
                    this.getJournalEntriesForDate(entryDate).then(() => {
                        this.$qui.notify(this.$qui.successNote);
                        // Toggle comment visibility if needed
                        setTimeout(() => {
                            this.toggleCommentVisiblity(QMC.Common.personalLocalStorage.getItem("lastComment"));
                            QMC.Common.personalLocalStorage.removeItem('lastComment');
                        }, 300);
                    });
                    this.form = angular.copy(this.initForm());
                    document.getElementById('add-journal-entry').style.display = 'none';
                    // Set style to smart actions
                    $('div .additional-field-dynamic').css('display', 'none');
                    this.smartAction.resetSmartAction();
                    if (this.markNewEntry) {
                        const newId = data.createdObjectId;
                        this.openMarkModal(newId, 370002);
                    }
                    /* Reset Form */
                    setTimeout(() => {
                        this.supportPlanForm = [];
                        this.form.participants = null;
                        this.participantsList = [];
                        $("#idList, #clientList").val("");
                        this.clearNewFormCache();
                    });
                })
                    .catch((e) => this.handleActionError(e))
                    .finally(() => {
                    this.saveLoading = false;
                });
            }
            /**
             * set the manual date, add the time to the date
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            setManualDateWithTime() {
                this.form.dateManual = this.$qui.addTimeToDate(this.dateManual, this.timeManual);
            }
            /**
             * Post a new comment to a journal entry
             */
            postComment(id, isWarning, index) {
                this.$qui.scopeApplyAsync(this.$scope).then(() => {
                    this.hideCommentModal();
                    this.form.commentTypeWvId = isWarning ? COMMENT_TYPE_WARNING_ID : COMMENT_TYPE_NORMAL_ID;
                    this.form.journalId = this.journalId;
                    this.form.parentEntryId = id;
                    this.form.comment = this.text[index];
                    this.form.warningReasons = this.buildWarningReasons();
                    this.saveLoading = true;
                    setTimeout(() => {
                        QMC.Common.personalLocalStorage.setItem("lastComment", id);
                        this.afterValidationAction = "postCommentPost";
                        this.validateJournalEntry({
                            date: new Date(),
                            creationTimeStamp: new Date(),
                            id: null,
                            authorId: null
                        });
                    }, 300);
                });
            }
            postCommentPost() {
                this.saveLoading = true;
                this.tagebuchService.postJournalEntry(this.form)
                    .then(() => {
                    this.form.comment = '';
                    this.smartAction.resetSmartAction();
                    // Load entries for today (comments are created with current date)
                    const commentDate = new Date();
                    this.getJournalEntriesForDate(commentDate).then(() => {
                        // Toggle comment visibility for the parent entry
                        setTimeout(() => {
                            this.toggleCommentVisiblity(QMC.Common.personalLocalStorage.getItem("lastComment"));
                            QMC.Common.personalLocalStorage.removeItem('lastComment');
                        }, 300);
                    });
                })
                    .catch((e) => this.handleActionError(e))
                    .finally(() => {
                    this.saveLoading = false;
                });
            }
            /**
             * Get journal entries for a specific date (silent, without loading indicator)
             * @private
             */
            getJournalEntriesForDate(date) {
                if (this.journalId === undefined)
                    return this.$q.resolve();
                const filter = this.createJournalFilter(0, 1000, moment(date).startOf('day').toDate(), moment(date).endOf('day').toDate());
                return this.tagebuchService.getJournalEntryList(this.journalId, filter)
                    .then((data) => {
                    this.processJournalEntries(data.items);
                    const processed = data.items.map(x => {
                        const entry = { ...x, isEditable: this.checkIfEditable(x) };
                        this.setEditableFlags(entry);
                        return entry;
                    });
                    this.mergeJournalEntries(processed);
                });
            }
            /**
             * Merge new journal entries with existing ones based on objectId
             * @private
             */
            mergeJournalEntries(newEntries) {
                if (!this.journalEntries || this.journalEntries.length === 0) {
                    this.journalEntries = newEntries;
                    this.dedupeMainJournalEntriesByObjectId();
                    return;
                }
                const existingMap = {};
                this.journalEntries.forEach(e => existingMap[e.objectId] = e);
                newEntries.forEach(newEntry => {
                    if (newEntry.parentId && newEntry.parentId !== QMC.Common.Constants.GUID_EMPTY) {
                        // Comment (subEntry) - update parent's subEntries
                        const parent = existingMap[newEntry.parentId];
                        if (parent) {
                            if (!parent.subEntries)
                                parent.subEntries = [];
                            let idx = -1;
                            for (let i = 0; i < parent.subEntries.length; i++) {
                                if (parent.subEntries[i].objectId === newEntry.objectId) {
                                    idx = i;
                                    break;
                                }
                            }
                            newEntry.isEditable = this.checkIfEditable(newEntry);
                            if (idx >= 0) {
                                parent.subEntries[idx] = newEntry;
                            }
                            else {
                                parent.subEntries.push(newEntry);
                                this.sortSubEntries(parent.subEntries);
                            }
                        }
                    }
                    else {
                        // Main entry - update or insert
                        const existing = existingMap[newEntry.objectId];
                        if (existing) {
                            // Update existing
                            if (existing.subEntries && (!newEntry.subEntries || newEntry.subEntries.length === 0)) {
                                newEntry.subEntries = existing.subEntries;
                            }
                            this.setEditableFlags(newEntry);
                            let idx = -1;
                            for (let i = 0; i < this.journalEntries.length; i++) {
                                if (this.journalEntries[i].objectId === newEntry.objectId) {
                                    idx = i;
                                    break;
                                }
                            }
                            if (idx >= 0 && this.compareEntries(newEntry, existing) !== 0) {
                                // Position changed - re-insert
                                this.journalEntries.splice(idx, 1);
                                this.journalEntries.splice(this.findInsertionIndex(newEntry), 0, newEntry);
                                existingMap[newEntry.objectId] = newEntry;
                            }
                            else if (idx >= 0) {
                                this.journalEntries[idx] = newEntry;
                                existingMap[newEntry.objectId] = newEntry;
                            }
                        }
                        else {
                            // New entry - check filter range and insert
                            const entryDate = newEntry.dateManual || newEntry.date;
                            if (entryDate &&
                                moment(entryDate).isSameOrAfter(moment(this.filter.filterDateFrom).startOf('day')) &&
                                moment(entryDate).isSameOrBefore(moment(this.filter.filterDateTo).endOf('day'))) {
                                this.setEditableFlags(newEntry);
                                this.journalEntries.splice(this.findInsertionIndex(newEntry), 0, newEntry);
                                existingMap[newEntry.objectId] = newEntry;
                            }
                        }
                    }
                });
                this.dedupeMainJournalEntriesByObjectId();
                this.checkMarkedItems();
                this.$qui.scopeApply(this.$scope);
            }
            /**
             * Keeps one main list row per objectId (first occurrence). Guards against merge/API edge cases and ng-repeat track by dupes.
             * @private
             */
            dedupeMainJournalEntriesByObjectId() {
                var _a;
                if (!((_a = this.journalEntries) === null || _a === void 0 ? void 0 : _a.length)) {
                    return;
                }
                const seen = {};
                this.journalEntries = this.journalEntries.filter((e) => {
                    const id = e && e.objectId;
                    if (!id) {
                        return true;
                    }
                    if (seen[id]) {
                        return false;
                    }
                    seen[id] = true;
                    return true;
                });
            }
            /**
             * get the list of journal entrys
             *
             * @private
             * @returns
             *
             * @memberOf TagebuchListController
             */
            getJournalEntries() {
                // reset infinte scroll variables
                this.alreadyLoad = true;
                this.scrollInit = false;
                this.lastPage = false;
                if (this.journalId === undefined && this.journalList !== undefined)
                    this.journalId = this.journalList[0].id;
                this.loading = true;
                this.journalEntries = null;
                const filter = this.createJournalFilter(this.listPage, this.pageSize);
                if (this.journalId === undefined)
                    return;
                this.tagebuchService.getJournalEntryList(this.journalId, filter).then((data) => {
                    this.loading = false;
                    // Process entries
                    this.processJournalEntries(data.items);
                    // Set isEditable flags
                    this.journalEntries = data.items.map(x => {
                        const entry = { ...x, isEditable: this.checkIfEditable(x) };
                        this.setEditableFlags(entry);
                        return entry;
                    });
                    this.dedupeMainJournalEntriesByObjectId();
                    this.pagination = data.paginationInfo;
                    this.paginationNavigation(Number(data.paginationInfo.totalPages));
                    this.page = filter.Page;
                    this.scrollInit = true;
                    this.alreadyLoad = false;
                    this.checkMarkedItems();
                    setTimeout(() => {
                        // Do not call events() here: it re-registers scroll handlers, $watch listeners, and
                        // Summernote init — once per page load is enough (see constructor $qui.init).
                        this.$qui.scheduleInitTooltip();
                        this.toggleCommentVisiblity(QMC.Common.personalLocalStorage.getItem("lastComment"));
                        QMC.Common.personalLocalStorage.removeItem('lastComment');
                    }, 500);
                });
            }
            /**
             * Check if items are marked and update the isMarked property
             */
            checkMarkedItems() {
                const startIndex = Math.max(0, this.journalEntries.length - this.pageSize);
                const itemList = [];
                for (let i = startIndex; i < this.journalEntries.length; i++) {
                    itemList.push(this.journalEntries[i].objectId);
                }
                if (itemList.length === 0)
                    return;
                this.markItemService.checkIfItemsAreMarked(itemList, 370002).then((data) => {
                    if (!data || data.length === 0)
                        return;
                    const markedMap = data.reduce((map, item) => {
                        var _a;
                        if (item === null || item === void 0 ? void 0 : item.key) {
                            map[item.key] = (_a = item.value) !== null && _a !== void 0 ? _a : false;
                        }
                        return map;
                    }, {});
                    if (!this.journalEntries || this.journalEntries.length === 0)
                        return;
                    this.journalEntries.forEach(entry => {
                        if (entry && entry.objectId && markedMap[entry.objectId] !== undefined) {
                            entry.isMarked = markedMap[entry.objectId];
                        }
                    });
                });
            }
            /**
             * Modifies an existing journal entry
             */
            updateJournalEntry(data, isSub) {
                var _a;
                this.updateEntry = data;
                const modForm = document.getElementById("modForm");
                if (modForm)
                    modForm.disabled = false;
                if (isSub) {
                    this.updateForm = {
                        id: data.id,
                        objectId: data.objectId,
                        comment: data.comment,
                        commentTypeWvId: data.commentTypeWvId,
                        livingAreaId: null,
                        parentEntryId: data.parentId,
                        participants: null,
                        priorityId: null,
                        isSub: true,
                        dateManual: this.$qui.createDateFromString(data.dateManual),
                        timeManual: this.$qui.createDateFromString(data.dateManual),
                        authorId: data.authorObjectId,
                        warningReasons: {}
                    };
                    this.elaborativeWarning = data.commentTypeWvId === QMC.Common.Constants.JOURNAL_COMMENTTYPE_WARNING && Object.keys(data.warningReasons).length > 0;
                    this.elaborativeWarningData = this.getInternalElobaritveWarningObject(data.warningReasons);
                }
                else {
                    this.updateForm = {
                        id: data.id,
                        objectId: data.objectId,
                        comment: data.comment,
                        commentTypeWvId: data.commentTypeWvId,
                        livingAreaId: data.livingAreaWvId === QMC.Common.Constants.GUID_EMPTY ? null : data.livingAreaWvId,
                        parentEntryId: data.parentId,
                        participants: [],
                        priorityId: data.priorityWvId === QMC.Common.Constants.GUID_EMPTY ? null : data.priorityWvId,
                        isSub: false,
                        dateManual: this.$qui.createDateFromString(data.dateManual),
                        timeManual: this.$qui.createDateFromString(data.dateManual),
                        authorId: data.authorObjectId
                    };
                    if ((_a = data.participants) === null || _a === void 0 ? void 0 : _a.length)
                        this.updateForm.participants = data.participants.map(x => x.objectId);
                    if (!this.updateForm.isSub && data.supportPlan) {
                        this.updateForm.supportPlanForm = [data.supportPlan];
                        this.updateForm.supportPlanForm[0].clientId = this.updateForm.participants[0];
                        this.updateForm.supportPlanForm[0].comment = data.comment;
                        this.updateForm.supportPlanForm[0].templateId = data.supportPlan.targetDefinitionId;
                        this.updateForm.supportPlanForm[0].templateItemId = data.supportPlan.templateItemId;
                    }
                }
                this.isEntryModWarning = this.updateForm.commentTypeWvId === QMC.Common.Constants.JOURNAL_COMMENTTYPE_WARNING && this.updateForm.isSub;
                this.saveLoading = false;
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                $("#modifyModal").modal("show");
                this.$qui.scopeApply(this.$scope);
            }
            saveUpdatedJournalEntry() {
                if (!this.modify)
                    return;
                if (this.updateForm.isSub) {
                    this.updateForm.commentTypeWvId = this.isEntryModWarning
                        ? QMC.Common.Constants.JOURNAL_COMMENTTYPE_WARNING
                        : QMC.Common.Constants.JOURNAL_COMMENTTYPE_NORMAL;
                }
                this.updateForm.warningReasons = this.createElobaritveWarningObject();
                this.updateForm.dateManual = this.$qui.addTimeToDate(this.updateForm.dateManual, this.updateForm.timeManual);
                if (this.disableModEntrySave()) {
                    return;
                }
                this.saveLoading = true;
                this.afterValidationAction = "updateJournalEntryPut";
                this.validateJournalEntry({
                    date: this.updateForm.dateManual ? this.updateForm.dateManual : new Date(),
                    creationTimeStamp: this.updateEntry.date,
                    id: this.updateForm.objectId,
                    authorId: this.updateForm.authorId
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            updateJournalEntryPut() {
                const form = angular.copy(this.updateForm);
                this.saveLoading = true;
                if (form.supportPlanForm) {
                    form.supportPlan = {
                        personId: form.supportPlanForm[0].clientId,
                        supportPlanId: form.supportPlanForm[0].supportPlanId,
                        templateId: form.supportPlanForm[0].templateId,
                        templateItemId: form.supportPlanForm[0].templateItemId
                    };
                    form.comment = form.supportPlanForm[0].comment;
                    form.livingAreaId = form.supportPlanForm[0].livingAreaId;
                }
                this.tagebuchService.putJournalEntry(form.objectId, form)
                    .then(() => {
                    this.$qui.notify(this.$qui.successNote);
                    // Determine the date of the updated entry
                    const entryDate = form.dateManual ? form.dateManual : new Date();
                    // Load entries for the specific day and merge them
                    this.getJournalEntriesForDate(entryDate).finally(() => {
                        $("#modifyModal").modal("hide");
                        this.saveLoading = false;
                    });
                    this.smartAction.resetSmartAction();
                })
                    .catch((e) => {
                    this.handleActionError(e);
                    this.saveLoading = false;
                });
            }
            handleActionError(e) {
                this.validation = {
                    errors: [this.lng.translate(20002002, 'Fehler beim Speichern der Daten')],
                    warnings: [],
                    loading: false
                };
                // Open modal after Angular applies bindings; jQuery .modal('show') otherwise can paint stale {{error}}.
                this.$scope.$applyAsync(() => {
                    $("#validationModal").modal("show");
                });
            }
            /**
             * Deletes an existing journal entry
             */
            deleteJournalEntry(id) {
                if (!this.delete)
                    return;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.tagebuchService.deleteJournalEntry(id).then(() => {
                            this.$qui.notify(this.$qui.deleteNote);
                            this.loadJournalAuthors(true);
                            this.getJournalEntries();
                        });
                });
            }
            getUserSettings() {
                const keys = [
                    "TAGEBUCH.SCHREIBSCHUTZ.MODUS",
                    "TAGEBUCH.BEGRENZUNGTYP",
                    "TAGEBUCH.BEGRENZUNGTAGE",
                    "TAGEBUCH.STD",
                    "TAGEBUCH.MIN",
                    "TAGEBUCH.WARNUNG.GRUND"
                ];
                this.userService.getUserSettings(keys, false).then((data) => {
                    this.writeProtection.authorOnly = this.getValue(data, "TAGEBUCH.SCHREIBSCHUTZ.MODUS", "0") === "0";
                    this.writeProtection.isActive = this.getValue(data, "TAGEBUCH.BEGRENZUNGTYP", "1") === "0";
                    this.writeProtection.allowedDaysIntoPast = parseInt(this.getValue(data, "TAGEBUCH.BEGRENZUNGTAGE", "0"), 10);
                    this.writeProtection.hours = parseInt(this.getValue(data, "TAGEBUCH.STD", "12"), 10);
                    this.writeProtection.minutes = parseInt(this.getValue(data, "TAGEBUCH.MIN", "0"), 10);
                    this.$qui.getTableAutoload(this.userService).then((ltd) => {
                        this.shouldLoadTableData = ltd;
                        if (this.shouldLoadTableData) {
                            this.getData();
                        }
                    });
                    this.enableWarningReason = this.getValue(data, "TAGEBUCH.WARNUNG.GRUND", "false").toLowerCase() === "true";
                });
                if (QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.JOURNAL_USE_CURRENT_DATE) !== null) {
                    this.useCurrentDate = JSON.parse(QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.JOURNAL_USE_CURRENT_DATE));
                }
            }
            /**
             * Helper function to get a value by name from a settings object
             */
            getValue(data, key, defaultValue = "") {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].key === key) {
                        const result = data[i].value;
                        return result && result !== "" ? result : defaultValue;
                    }
                }
                return defaultValue;
            }
            /**
             * Checks if an entry is editable based on write protection settings
             */
            checkIfEditable(entry) {
                if (!(entry === null || entry === void 0 ? void 0 : entry.authorObjectId))
                    return false;
                const sessionElement = document.getElementById("session");
                if (!sessionElement)
                    return false;
                const userId = sessionElement.getAttribute("data-user-id");
                if (this.writeProtection.authorOnly &&
                    entry.authorObjectId.toLocaleLowerCase() !== (userId === null || userId === void 0 ? void 0 : userId.toLocaleLowerCase())) {
                    return false;
                }
                if (!this.writeProtection.isActive)
                    return true;
                const createdDate = this.$qui.createDateFromString(entry.date);
                const lockDate = this.addDays(createdDate, this.writeProtection.allowedDaysIntoPast);
                lockDate.setHours(this.writeProtection.hours, this.writeProtection.minutes, 0, 0);
                return new Date() <= lockDate;
            }
            addDays(date, days) {
                const result = this.$qui.createDateFromString(date);
                result.setDate(result.getDate() + days);
                return result;
            }
            /**
             * create the pagination navigation
             *
             * @private
             * @param {number} count
             *
             * @memberOf TagebuchListController
             */
            paginationNavigation(count) {
                this.paginationNav = Array.from({ length: count }, (_, i) => i + 1);
            }
            /**
             * change the page of the pagination navigation
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            changePage() {
                if (this.pagination.totalPages === 0)
                    return;
                this.page++;
                if (this.journalId === undefined)
                    this.journalId = this.journalList[0].id;
                this.loadingMore = true;
                const filter = this.createJournalFilter(this.page, this.pageSize);
                this.tagebuchService.getJournalEntryList(this.journalId, filter).then((data) => {
                    var _a, _b, _c;
                    // Process entries
                    this.processJournalEntries(data.items);
                    // Set isEditable flags
                    data.items = data.items.map(x => {
                        const entry = { ...x, isEditable: this.checkIfEditable(x) };
                        this.setEditableFlags(entry);
                        return entry;
                    });
                    this.loadingMore = false;
                    this.loading = false;
                    for (const item of data.items) {
                        let idx = -1;
                        for (let j = 0; j < ((_b = (_a = this.journalEntries) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); j++) {
                            if (this.journalEntries[j].objectId === item.objectId) {
                                idx = j;
                                break;
                            }
                        }
                        if (idx < 0) {
                            this.journalEntries.push(item);
                        }
                        else {
                            if (((_c = this.journalEntries[idx].subEntries) === null || _c === void 0 ? void 0 : _c.length) && (!item.subEntries || item.subEntries.length === 0)) {
                                item.subEntries = this.journalEntries[idx].subEntries;
                            }
                            this.setEditableFlags(item);
                            this.journalEntries[idx] = item;
                        }
                    }
                    this.dedupeMainJournalEntriesByObjectId();
                    this.checkMarkedItems();
                    this.pagination = data.paginationInfo;
                    if (this.page === this.pagination.totalPages)
                        this.lastPage = true;
                    this.alreadyLoad = false;
                    setTimeout(() => {
                        // Do not call events() here: it re-registers scroll handlers, $watch listeners, and
                        // Summernote init — once per page load is enough (see constructor $qui.init).
                        this.$qui.scheduleInitTooltip();
                        this.toggleCommentVisiblity(QMC.Common.personalLocalStorage.getItem("lastComment"));
                        QMC.Common.personalLocalStorage.removeItem('lastComment');
                    }, 500);
                });
            }
            /**
             * get the list of aviable journals
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            getJournals() {
                this.loading = true;
                this.tagebuchService.getJournalList().then((data) => {
                    this.journalList = data;
                    this.loading = false;
                    this.maps.journal = data.map(x => ({ value: x.id, text: x.caption, subText: x.type, icon: x.isClosed ? 'qm-icon-lock' : undefined })).sort((a, b) => { return a.text > b.text ? 1 : a.text < b.text ? -1 : 0; });
                    let journalExists = false;
                    for (let i = 0; i < this.maps.journal.length; i++) {
                        if (this.maps.journal[i].value === this.journalId) {
                            journalExists = true;
                            break;
                        }
                    }
                    if (!this.journalId || !journalExists) {
                        this.journalId = this.maps.journal.length > 0 ? this.maps.journal[0].value : undefined;
                    }
                    this.getWvList(this.journalId);
                });
            }
            showCommentModal(id) {
                this.text = [];
                this.warning = [];
                $('#commentModal').modal('show');
                this.toggleNavHeader();
                this.commentEntryId = id;
                this.elaborativeWarningData = {};
                this.elaborativeWarning = false;
            }
            hideCommentModal() {
                this.toggleNavHeader();
                $('#commentModal').modal('hide');
                this.commentEntryId = null;
            }
            toggleNavHeader() {
                if (this.isMobile) {
                    if ($('.qm-page-header').is(":visible")) {
                        $('#close-nav').hide();
                        $('.qm-page-header').hide();
                    }
                    else {
                        $('#close-nav').show();
                        $('.qm-page-header').show();
                    }
                }
            }
            print() {
                const areas = document.getElementsByName('printableAreas');
                const winPrint = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
                for (let i = 0; i < areas.length; i++) {
                    winPrint.document.write(areas[i].innerHTML);
                    if (i % 2 === 1)
                        winPrint.document.write("<br /><br />");
                }
                winPrint.document.close();
                winPrint.focus();
                winPrint.print();
                winPrint.close();
            }
            validateJournalEntry(entry) {
                this.validation = {
                    errors: [],
                    warnings: [],
                    loading: true
                };
                this.saveLoading = true;
                const gen = ++this.validationGeneration;
                this.tagebuchService.postValidation(entry)
                    .then((data) => {
                    if (gen !== this.validationGeneration)
                        return;
                    this.validation.warnings = data.warnings;
                    this.validation.errors = data.errors;
                    if (data.warnings.length > 0 || data.errors.length > 0) {
                        $('#validationModal').modal('show');
                        this.saveLoading = false;
                    }
                    else
                        this.continueSaving();
                })
                    .catch((e) => {
                    if (gen !== this.validationGeneration)
                        return;
                    console.log('Validation error', e);
                    this.validation.errors.push(this.lng.translate(0, "Der Eintrag konnte nicht validiert werden"));
                    $('#validationModal').modal('show');
                    this.saveLoading = false;
                })
                    .finally(() => {
                    if (gen === this.validationGeneration)
                        this.validation.loading = false;
                });
            }
            continueSaving() {
                $('#validationModal').modal('hide');
                if (!this.afterValidationAction)
                    return;
                const action = this[this.afterValidationAction];
                if (action && typeof action === 'function') {
                    // Bind the method to preserve 'this' context
                    action.call(this);
                }
            }
            getJournalName() {
                if (!this.journalList)
                    return '';
                for (let i = 0; i < this.journalList.length; i++) {
                    if (this.journalList[i].objectId === this.journalId) {
                        return this.journalList[i].caption;
                    }
                }
                return '';
            }
            getNoticeSubject() {
                const journalName = this.getJournalName();
                return this.$qui.formatString(this.lng.translate(20000248, "Gemeldeter Datensatz: {0} ({1})"), journalName, this.lng.translate(20001007, 'Tagebuch'));
            }
            getNoticeMessage(entry) {
                const journalName = this.getJournalName();
                return this.$qui.formatString(this.lng.translate(20000249, "Gemeldeter Datensatz: '{0}', '{1}' bei '{2}'."), this.lng.translate(20001007, 'Tagebuch'), entry.comment, journalName);
            }
            openQuickMessage(entry) {
                this.quickMessage.subject = this.getNoticeSubject();
                this.quickMessage.message = this.getNoticeMessage(entry);
                this.quickMessage.open = false;
                this.$timeout(() => {
                    this.quickMessage.open = true;
                }, 0);
            }
            disableSupportPlan() {
                if (!this.participantsList || this.participantsList.length === 0) {
                    this.newEntrySupportPlan = false;
                    return true;
                }
                for (const part of this.participantsList) {
                    if (this.possibleParticipants && this.possibleParticipants.some(x => x.objectId === part && x.objectType === 140000))
                        return false;
                }
                return true;
            }
            /****************************** ElaborativeWarning ********************************/
            openElaborativeWarningModal() {
                if (this.elaborativeWarning) {
                    $('#elaborativeWarningModal').modal('show');
                }
            }
            /**
             * Build warning reasons object from elaborative warning data
             */
            buildWarningReasons() {
                const result = {};
                Object.keys(this.elaborativeWarningData).forEach(key => {
                    if (this.elaborativeWarningData[key].active) {
                        result[key] = this.elaborativeWarningData[key].comment;
                    }
                });
                return result;
            }
            createElobaritveWarningObject() {
                return this.buildWarningReasons();
            }
            getInternalElobaritveWarningObject(data) {
                const result = {};
                Object.keys(data).forEach(id => {
                    result[id] = { active: true, comment: data[id] };
                });
                return result;
            }
        };
        TagebuchListController = __decorate([
            QMC.Controller('QMC.Tagebuch', 'TagebuchListController'),
            QMC.Inject('$location', 'TagebuchService', '$qui', 'KlientService', '$state', '$scope', 'QmcLanguageService', 'QmcPermissionService', 'UserService', 'QmcMarkItemService', '$sce', '$stateParams', 'StammdatenService', 'QmcUdfService', '$q', '$timeout')
        ], TagebuchListController);
    })(Tagebuch = QMC.Tagebuch || (QMC.Tagebuch = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Tagebuch;
    (function (Tagebuch) {
        let TagebuchDetailController = class TagebuchDetailController {
            constructor($location, $scope, $qui, $state, $sce, tagebuchService, permissionService, userService, lng, markItemService, stammdatenService) {
                this.$location = $location;
                this.$scope = $scope;
                this.$qui = $qui;
                this.$state = $state;
                this.$sce = $sce;
                this.tagebuchService = tagebuchService;
                this.permissionService = permissionService;
                this.userService = userService;
                this.lng = lng;
                this.markItemService = markItemService;
                this.stammdatenService = stammdatenService;
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.loading = {
                    entry: true,
                    permission: true,
                    save: false,
                    settings: true,
                    validation: false,
                    wv: true
                };
                this.writeProtection = {
                    authorOnly: false,
                    isActive: false,
                    allowedDaysIntoPast: 0,
                    hours: 0,
                    minutes: 0
                };
                this.validation = {
                    errors: [],
                    warnings: []
                };
                this.warningReason = '';
                this.enableWarningReason = false;
                this.headerText = '';
                $qui.init($qui.getSectionColor(this.$location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (!$state.params.id)
                    $state.go('journal');
                this.promptOptions = {
                    title: "Tagebuch",
                    yesNo: true,
                    icon: "qm-icon-note_pinned",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.tagebuchService.getJournalEntry($state.params.id).then((data) => {
                    this.entry = data;
                    this.loading.entry = false;
                    if (!data) {
                        this.error = true;
                    }
                    this.checkMarkedItems();
                    this.tagebuchService.getJournalList().then((data) => {
                        const journalName = data.filter(x => x.objectId === this.entry.journalId)[0].caption;
                        this.headerText = `(${journalName}) ${this.lng.translate(20000218, 'vom')} ${moment(this.entry.date).format('DD.MM.YYYY HH:mm')}`;
                    });
                    this.tagebuchService.getJournalEntryWv(this.entry.journalId).then((data) => {
                        this.wvs = data;
                        this.maps = {
                            priority: this.wvs.priorityWvList.map(x => ({ value: x.objectId, text: x.name })),
                            livingArea: this.wvs.livingAreaWvList.map(x => ({ value: x.objectId, text: x.name })),
                            clients: []
                        };
                        this.stammdatenService.getParticipantsSelectionAssignment('TAGEBUCHBETEILIGTE').then((data) => {
                            this.maps.clients = data.map(x => ({ value: x.objectId, text: x.displayTitle, group: x.objectTypeCaption }));
                            this.maps.clients.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                            this.maps.clients.sort((a, b) => (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0));
                            this.loading.wv = false;
                        });
                    });
                }).catch((e) => {
                    console.log(e);
                    this.error = true;
                    this.loading.entry = false;
                    this.loading.settings = false;
                    this.loading.permission = false;
                    this.loading.wv = false;
                });
                this.permissionService.getPermissionsByObjectTypes([370002]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.loading.permission = false;
                });
                this.userService.getUserSettings(['TAGEBUCH.SCHREIBSCHUTZ.MODUS', 'TAGEBUCH.BEGRENZUNGTYP', 'TAGEBUCH.BEGRENZUNGTAGE', 'TAGEBUCH.STD', 'TAGEBUCH.MIN', 'TAGEBUCH.WARNUNG.GRUND'], false).then((data) => {
                    this.writeProtection.authorOnly = this.getValue(data, "TAGEBUCH.SCHREIBSCHUTZ.MODUS", "0") === "0";
                    this.writeProtection.isActive = this.getValue(data, "TAGEBUCH.BEGRENZUNGTYP", "1") === "0";
                    this.writeProtection.allowedDaysIntoPast = parseInt(this.getValue(data, "TAGEBUCH.BEGRENZUNGTAGE", "0"));
                    this.writeProtection.hours = parseInt(this.getValue(data, "TAGEBUCH.STD", "12"));
                    this.writeProtection.minutes = parseInt(this.getValue(data, "TAGEBUCH.MIN", "0"));
                    this.enableWarningReason = this.getValue(data, 'TAGEBUCH.WARNUNG.GRUND', 'false').toLowerCase() === 'true';
                    this.loading.settings = false;
                });
            }
            /////////////// HELPER FUNCTIONS ///////////////
            getValue(data, key, defaultValue = "") {
                if (!defaultValue)
                    defaultValue = "";
                const result = $.grep(data, function (e) { return e.key === key; })[0].value;
                if (!result || result === "")
                    return defaultValue;
                return result;
            }
            checkIfEditable(entry) {
                if (!entry)
                    return false;
                const userId = document.getElementById("session").getAttribute("data-user-id");
                if (this.writeProtection.authorOnly && entry.authorObjectId.toLocaleLowerCase() !== userId.toLocaleLowerCase())
                    return false;
                if (!this.writeProtection.isActive)
                    return true;
                const createdDate = this.$qui.createDateFromString(entry.date);
                const lockDate = this.addDays(createdDate, this.writeProtection.allowedDaysIntoPast);
                lockDate.setHours(this.writeProtection.hours);
                lockDate.setMinutes(this.writeProtection.minutes);
                lockDate.setSeconds(0);
                return new Date() <= lockDate;
            }
            addDays(date, days) {
                const result = this.$qui.createDateFromString(date);
                result.setDate(result.getDate() + days);
                return result;
            }
            countSubWarnings(subs) {
                if (!subs || subs.length === 0)
                    return 0;
                let count = 0;
                for (const item of subs) {
                    if (item.commentTypeWvId === '7d1d5043-fe48-4b93-be38-c2bfd8e41d08')
                        count++;
                }
                return count;
            }
            toggleCommentVisiblity(id) {
                $(`#${id}`).slideToggle();
                this.$qui.scopeApply(this.$scope);
            }
            areSubsHidden(id) {
                return $(`#${id}`).css('display') === 'none';
            }
            showCommentModal(id) {
                this.comment.text = '';
                this.warningReason = '';
                $('#commentModal').modal('show');
                this.commentEntryId = id;
            }
            trustAsHtml(string) {
                return this.$sce.trustAsHtml(string);
            }
            ;
            strip(html) {
                if (!html)
                    return "";
                const textEl = document.createElement("div");
                textEl.innerHTML = html;
                return textEl.textContent.trim();
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            checkMarkedItems() {
                this.markItemService.checkIfItemsAreMarked([this.$state.params.id], 370002).then((data) => {
                    this.entry.isMarked = data[0].value;
                });
            }
            deleteJournalEntry(id) {
                if (!this.delete)
                    return;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.loading.save = true;
                        this.tagebuchService.deleteJournalEntry(id).then(() => {
                            this.$qui.notify(this.$qui.deleteNote);
                            this.loading.save = false;
                            if (id === this.entry.objectId)
                                this.$state.go('journal', { id: this.entry.journalId });
                            else {
                                this.loading.entry = true;
                                this.tagebuchService.getJournalEntry(this.$state.params.id).then((data) => {
                                    this.entry = data;
                                    this.loading.entry = false;
                                    this.checkMarkedItems();
                                });
                            }
                        });
                    }
                });
            }
            updateJournalEntry(data, isSub) {
                this.warningReason = data.commentTypeWvId === '7d1d5043-fe48-4b93-be38-c2bfd8e41d08' ? data.warningReason : '';
                console.log("MODIFY", data, isSub);
                if (isSub) {
                    this.updateForm = {
                        id: data.id,
                        objectId: data.objectId,
                        comment: data.comment,
                        commentTypeWvId: data.commentTypeWvId,
                        livingAreaId: null,
                        parentEntryId: data.parentId,
                        participants: null,
                        priorityId: null,
                        isSub: true,
                        dateManual: this.$qui.createDateFromString(data.dateManual),
                        timeManual: this.$qui.createDateFromString(data.dateManual),
                        authorId: data.authorObjectId,
                        warningReason: this.warningReason
                    };
                }
                else {
                    this.warningReason = '';
                    this.updateForm = {
                        id: data.id,
                        objectId: data.objectId,
                        comment: data.comment,
                        commentTypeWvId: data.commentTypeWvId,
                        livingAreaId: data.livingAreaWvId === QMC.Common.Constants.GUID_EMPTY ? null : data.livingAreaWvId,
                        parentEntryId: data.parentId,
                        participants: [],
                        priorityId: data.priorityWvId === QMC.Common.Constants.GUID_EMPTY ? null : data.priorityWvId,
                        isSub: false,
                        dateManual: this.$qui.createDateFromString(data.dateManual),
                        timeManual: this.$qui.createDateFromString(data.dateManual),
                        authorId: data.authorObjectId
                    };
                    if (data.participants !== null && data.participants !== undefined)
                        for (let i = 0; i < data.participants.length; i++)
                            this.updateForm.participants.push(data.participants[i].objectId);
                }
                this.isEntryModWarning = this.updateForm.commentTypeWvId === QMC.Common.Constants.JOURNAL_COMMENTTYPE_WARNING && this.updateForm.isSub;
                $("#modifyModal").modal("show");
            }
            saveUpdatedJournalEntry() {
                if (!this.modify)
                    return;
                if (this.isEntryModWarning && this.updateForm.isSub) {
                    this.updateForm.commentTypeWvId = QMC.Common.Constants.JOURNAL_COMMENTTYPE_WARNING;
                }
                if (!this.isEntryModWarning && this.updateForm.isSub) {
                    this.updateForm.commentTypeWvId = QMC.Common.Constants.JOURNAL_COMMENTTYPE_NORMAL;
                }
                this.updateForm.warningReason = this.warningReason;
                this.updateForm.dateManual = this.$qui.addTimeToDate(this.updateForm.dateManual, this.updateForm.timeManual),
                    this.loading.save = true;
                console.log(this.updateForm);
                this.afterValidationAction = "updateJournalEntryPut";
                this.validateJournalEntry({
                    date: this.updateForm.dateManual,
                    creationTimeStamp: this.updateForm.timeManual,
                    id: this.updateForm.objectId,
                    authorId: this.updateForm.authorId
                });
            }
            updateJournalEntryPut() {
                this.loading.save = true;
                this.tagebuchService.putJournalEntry(this.updateForm.objectId, this.updateForm).then(() => {
                    this.$qui.notify(this.$qui.successNote);
                    this.loading.entry = true;
                    this.tagebuchService.getJournalEntry(this.$state.params.id).then((data) => {
                        this.entry = data;
                        this.loading.entry = false;
                        this.checkMarkedItems();
                    });
                    $("#modifyModal").modal("hide");
                    this.loading.save = false;
                });
            }
            validateJournalEntry(entry) {
                this.validation.warnings = [];
                this.validation.errors = [];
                this.loading.validation = true;
                this.tagebuchService.postValidation(entry).then((data) => {
                    this.validation.warnings = data.warnings;
                    this.validation.errors = data.errors;
                    if (data.warnings.length > 0 || data.errors.length > 0)
                        $('#validationModal').modal('show');
                    else {
                        $('#validationModal').modal('hide');
                        this[this.afterValidationAction]();
                    }
                }).catch(() => {
                    this.validation.errors.push(this.lng.translate(0, "Der Eintrag konnte nicht validiert werden"));
                    $('#validationModal').modal('show');
                }).finally(() => {
                    this.loading.save = false;
                    this.loading.validation = false;
                });
            }
            postComment(id, isWarning) {
                this.comment.type = isWarning ? '7d1d5043-fe48-4b93-be38-c2bfd8e41d08' : 'b22fa7fc-8d14-4ae1-8483-729c5df12c07';
                this.comment.warningReason = isWarning ? this.warningReason : '';
                this.afterValidationAction = "postCommentPost";
                this.validateJournalEntry({
                    date: new Date(),
                    id: null,
                    authorId: null
                });
                $("#commentModal").modal("hide");
            }
            postCommentPost() {
                this.loading.save = true;
                this.tagebuchService.postJournalEntry({ comment: this.comment.text, journalId: this.entry.journalId, commentTypeWvId: this.comment.type, parentEntryId: this.entry.objectId, warningReason: this.comment.warningReason }).then(() => {
                    this.comment = { text: '', warning: false, type: '' };
                    this.loading.save = true;
                    this.tagebuchService.getJournalEntry(this.$state.params.id).then((data) => {
                        this.entry = data;
                        this.loading.save = false;
                        this.checkMarkedItems();
                    });
                });
            }
        };
        TagebuchDetailController = __decorate([
            QMC.Controller('QMC.Tagebuch', 'TagebuchDetailController'),
            QMC.Inject('$location', '$scope', '$qui', '$state', '$sce', 'TagebuchService', 'QmcPermissionService', 'UserService', 'QmcLanguageService', 'QmcMarkItemService', 'StammdatenService')
        ], TagebuchDetailController);
    })(Tagebuch = QMC.Tagebuch || (QMC.Tagebuch = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Tagebuch;
    (function (Tagebuch) {
        let TagebuchSupportPlanDirective = class TagebuchSupportPlanDirective {
            constructor($qui, journalService, lng) {
                this.$qui = $qui;
                this.journalService = journalService;
                this.lng = lng;
                this.restrict = 'E';
                this.templateUrl = './journal/SupportPlanDirective';
                this.replace = true;
                this.scope = {
                    qmParticipants: '=',
                    qmPossibleParticipants: '=',
                    qmForm: '=',
                    qmEnabled: '=',
                    qmSmartAction: '=',
                    qmSingle: '=',
                    qmId: '@',
                    qmDisabled: '=?',
                    qmDate: '='
                };
                this.documentableItemTypes = [
                    3,
                    4 //massnahme
                ];
                this.link = (scope) => {
                    if (!scope.qmId)
                        scope.qmId = '_' + Math.random().toString(36).substring(2, 11);
                    scope.supportPlanWarning = [];
                    scope.supportPlanData = {};
                    scope.$watch('qmParticipants', (newValue, oldValue) => {
                        if (newValue !== oldValue || (scope.qmSingle && scope.qmParticipants && scope.qmParticipants.length === 1))
                            scope.initData();
                    });
                    scope.$watch('qmEnabled', (newValue, oldValue) => {
                        if (newValue !== oldValue && scope.qmEnabled)
                            scope.initData();
                    });
                    scope.$watch('qmDate', (newValue, oldValue) => {
                        if (newValue !== oldValue && scope.qmDate) {
                            scope.initData();
                        }
                    });
                    scope.initData = () => {
                        if (!scope.qmEnabled)
                            return;
                        scope.supportPlanWarning = [];
                        for (const id of scope.qmParticipants) {
                            const participantData = scope.qmPossibleParticipants.filter(x => x.objectId === id)[0];
                            if (!participantData)
                                continue;
                            if (participantData.objectType !== 140000 && !scope.supportPlanWarning.some(x => x === participantData.displayTitle)) {
                                scope.supportPlanWarning.push(participantData.displayTitle);
                                scope.supportPlanWarning.sort();
                            }
                            if (scope.supportPlanData[id] && (!scope.supportPlanData[id].templates || scope.supportPlanData[id].templates.length === 0) && !scope.supportPlanData[id].loadTemplates && !scope.supportPlanWarning.some(x => x === participantData.displayTitle)) {
                                scope.supportPlanWarning.push(participantData.displayTitle);
                                scope.supportPlanWarning.sort();
                                continue;
                            }
                            if (participantData.objectType === 140000) {
                                participantData.loadTemplates = true;
                                scope.loadSupportPlanTemplates(id, scope.qmParticipants.indexOf(id));
                                if (!(scope.qmSingle && scope.qmForm.length === 1) && !scope.qmForm.some(x => x.clientId === id))
                                    scope.addSupportPlanForm(id);
                                else
                                    this.$qui.waitForEl(`#supportPlanFormButton-${scope.qmId}-0`, () => { document.getElementById(`supportPlanFormButton-${scope.qmId}-0`).click(); });
                            }
                            scope.supportPlanData[id] = participantData;
                        }
                        // remove all deleted participants from data
                        for (const id in scope.supportPlanData) {
                            if (scope.qmParticipants.some(x => x === id))
                                continue;
                            delete scope.supportPlanData[id];
                            for (let i = scope.qmForm.length - 1; i > -1; i--) {
                                if (scope.qmForm[i].clientId === id)
                                    scope.removeSupportPlanForm(i);
                            }
                        }
                        scope.qmClients = [];
                        for (const prop in scope.supportPlanData) {
                            if (scope.supportPlanData[prop].objectType === 140000) {
                                scope.qmClients.push({ text: scope.supportPlanData[prop].displayTitle, value: scope.supportPlanData[prop].objectId });
                            }
                        }
                    };
                    scope.addSupportPlanForm = (clientId = null) => {
                        const index = scope.qmForm.length;
                        clientId = clientId || scope.qmClients[0].value;
                        const spd = scope.supportPlanData[clientId];
                        scope.qmForm.push({
                            clientId: clientId,
                            templateId: (spd === null || spd === void 0 ? void 0 : spd.templates[0]) ? spd.templates[0].value : null,
                            templateItemId: (spd === null || spd === void 0 ? void 0 : spd.templates[0]) && spd.templateItems[spd.templates[0].value][0] ? spd.templateItems[spd.templates[0].value][0].value : null,
                            comment: '',
                            createSummernote: Function,
                            watcher: scope.$watch(`qmForm[${index}].clientId`, (newValue, oldValue) => {
                                if (newValue !== oldValue)
                                    scope.resetSupportPlanForm(scope.qmForm[index]);
                            })
                        });
                        setTimeout(() => {
                            this.$qui.waitForEl(`#supportPlanFormButton-${scope.qmId}-${index}`, () => { document.getElementById(`supportPlanFormButton-${scope.qmId}-${index}`).click(); });
                        });
                    };
                    scope.getClientName = (id) => {
                        const participantData = scope.qmClients.filter(x => x.value === id)[0];
                        if (!participantData)
                            return '';
                        return participantData.text;
                    };
                    scope.removeSupportPlanForm = (index) => {
                        const selected = document.getElementById(`supportPlanFormButton-${scope.qmId}-${index}`).parentElement.classList.contains('active');
                        // if last element was selected and deleted select, the new last element (supposed it exists)
                        if (selected && scope.qmForm.length - 1 === index && scope.qmForm.length > 1) {
                            document.getElementById(`supportPlanFormButton-${scope.qmId}-${index - 1}`).click();
                            document.getElementById(`supportPlanForm-${scope.qmId}-${index - 1}`).classList.add('active', 'in');
                        }
                        scope.qmForm.splice(index, 1);
                    };
                    scope.resetSupportPlanForm = (form) => {
                        var _a, _b;
                        if (!form)
                            return;
                        const spd = scope.supportPlanData[form.clientId];
                        form.templateId = (_a = spd === null || spd === void 0 ? void 0 : spd.templates[0]) === null || _a === void 0 ? void 0 : _a.value;
                        form.templateItemId = form.templateId && (spd === null || spd === void 0 ? void 0 : spd.templateItems[form.templateId]) && ((_b = spd === null || spd === void 0 ? void 0 : spd.templateItems[form.templateId][0]) === null || _b === void 0 ? void 0 : _b.value);
                    };
                    scope.getLivingAreaName = (clientId, templateId, templateItemId, index) => {
                        if (!scope.supportPlanData[clientId] || !scope.supportPlanData[clientId].templateItemOriginals || !scope.supportPlanData[clientId].templateItemOriginals[templateId])
                            return '';
                        const templateItems = this.getChildsFromTemplateItems(scope.supportPlanData[clientId].templateItemOriginals[templateId]);
                        let item = templateItems.filter(x => x.objectId === templateItemId)[0];
                        if (!item)
                            return '';
                        while (item.parentId) {
                            item = templateItems.filter(x => x.objectId === item.parentId)[0];
                            if (!item)
                                return '';
                        }
                        if (scope.qmForm[index]) {
                            scope.qmForm[index].livingAreaId = item.reportItemId;
                        }
                        return item.caption;
                    };
                    scope.loadSupportPlanTemplates = (id, index) => {
                        this.journalService.getSupportPlanTargetTemplates(id).then((dataSupportPlan) => {
                            dataSupportPlan = dataSupportPlan
                                .sort((a, b) => {
                                const fromA = moment(a.dateFrom);
                                const fromB = moment(b.dateFrom);
                                return fromA < fromB ? 1 : fromA > fromB ? -1 : 0;
                            })
                                .filter(x => ((moment(x.dateFrom).startOf('day') <= moment(scope.qmDate).startOf('day')) || x.dateFrom == null)
                                && ((moment(x.dateTo).startOf('day') >= moment(scope.qmDate).startOf('day')) || x.dateTo == null));
                            scope.supportPlanData[id].templates = dataSupportPlan.map(x => ({
                                text: x.caption, subText: x.supportPlanCaption, value: x.id
                            }));
                            scope.supportPlanData[id].templateOriginals = dataSupportPlan;
                            // if we got templates (a support plan exists) select the first one, else remove client from list
                            if (scope.supportPlanData[id].templates.length > 0) {
                                scope.qmForm[index].templateId = scope.supportPlanData[id].templates[0].value;
                                for (const item of scope.supportPlanData[id].templates) {
                                    scope.loadSupportPlanTemplateItems(item.value, id, scope.qmForm[index].templateId, index);
                                }
                                // get the last phase
                                scope.supportPlanData[id].activeSupportPlanPhaseTitel = '';
                                scope.supportPlanData[id].activeSupportPlanPhaseName = '';
                                scope.supportPlanData[id].activeSupportPlanPhaseText = '';
                                scope.supportPlanData[id].activeSupportPlanPhaseLink = '';
                                // Select the first entry from the array
                                const firstTemplate = dataSupportPlan[0];
                                if (firstTemplate) {
                                    //get active phase from careplan
                                    this.journalService.getSupportPlanActivePhase(firstTemplate.supportPlanId).then((dataPhase) => {
                                        if (dataPhase.careplanId) {
                                            if ((dataPhase.phase != 'CareSummarization') && (dataPhase.phaseState != 'IsDone')) {
                                                if (dataPhase && dataPhase.phase) {
                                                    // fill variables
                                                    scope.supportPlanData[id].dataPhase = dataPhase;
                                                    if (dataPhase.phaseState) {
                                                        scope.supportPlanData[id].activeSupportPlanPhaseColor =
                                                            QMC.Common.SupportPlanHelper.getActiveSupportPlanPhaseColor(dataPhase.phaseState);
                                                    }
                                                    scope.supportPlanData[id].activeSupportPlanPhaseName =
                                                        QMC.Common.SupportPlanHelper.getActiveSupportPlanPhase(dataPhase.phase, this.lng);
                                                    scope.supportPlanData[id].activeSupportPlanPhaseText =
                                                        QMC.Common.SupportPlanHelper.getActiveSupportPlanPhaseText(dataPhase, this.lng, this.$qui);
                                                    scope.supportPlanData[id].activeSupportPlanPhaseLink =
                                                        QMC.Common.SupportPlanHelper.getActiveSupportPlanLink(dataPhase.careplanId);
                                                    scope.supportPlanData[id].activeSupportPlanPhaseTitel =
                                                        this.lng.translate(0, 'Akt. Status Betreuungsplan');
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                            else {
                                const client = scope.qmClients.filter(x => x.value === id)[0];
                                scope.supportPlanWarning.push(client.text);
                                scope.supportPlanWarning.sort().filter((v, i, a) => a.indexOf(v) === i);
                                scope.removeSupportPlanForm(scope.qmForm.findIndex(x => x.clientId === id));
                            }
                        }).finally(() => {
                            scope.supportPlanData[id].loadTemplates = false;
                            for (const client of scope.qmClients) {
                                if (!scope.supportPlanData[client.value].loadTemplates && (!scope.supportPlanData[client.value].templates || scope.supportPlanData[client.value].templates.length === 0))
                                    scope.qmClients = scope.qmClients.filter(x => x.value !== client.value);
                            }
                        });
                    };
                    scope.loadSupportPlanTemplateItems = (id, clientId, templateId, index) => {
                        if (!scope.supportPlanData[clientId].templateItems) {
                            scope.supportPlanData[clientId].templateItems = {};
                        }
                        if (!scope.supportPlanData[clientId].templateItemOriginals) {
                            scope.supportPlanData[clientId].templateItemOriginals = {};
                        }
                        if (scope.supportPlanData[clientId].templateItems[id])
                            return;
                        scope.supportPlanData[clientId].templateItems[id] = 'loading';
                        const getIcon = (element) => {
                            if (element.measureId)
                                return 'qm-icon-lifebelt';
                            if (element.targetId)
                                return 'qm-icon-target';
                            return 'qm-icon-elements';
                        };
                        const flatten = (elements, level = 0) => {
                            var _a;
                            const result = [];
                            for (const item of elements) {
                                item.level = level;
                                result.push(item);
                                if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length)
                                    result.push(...flatten(item.children, level + 1));
                            }
                            return result;
                        };
                        this.journalService.getSupportPlanTargetTemplateItems(id).then((data) => {
                            // first break up hierachy
                            const items = flatten(data).map(x => ({ text: x.caption, value: x.objectId, icon: getIcon(x), level: x.level, disabled: !this.documentableItemTypes.includes(x.itemType) }));
                            // then map
                            scope.supportPlanData[clientId].templateItems[id] = items;
                            scope.supportPlanData[clientId].templateItemOriginals[id] = data;
                            const templateItems = scope.supportPlanData[clientId].templateItems[templateId];
                            if (templateItems && templateItems.length > 0)
                                scope.qmForm[index].templateItemId = templateItems[0].value;
                        }).finally(() => {
                            if (!scope.supportPlanData[clientId].templateItems[id])
                                scope.supportPlanData[clientId].templateItems[id] = [];
                            if (!scope.supportPlanData[clientId].templateItemOriginals[id])
                                scope.supportPlanData[clientId].templateItemOriginals[id] = [];
                        });
                    };
                    scope.isFormInvalid = (index) => {
                        var _a, _b, _c;
                        const form = scope.qmForm[index];
                        form.valid = form.templateId && form.templateItemId && this.strip((_a = form.comment) !== null && _a !== void 0 ? _a : '').length > 0
                            && (!scope.supportPlanData[form.clientId].loadTemplates
                                && scope.supportPlanData[form.clientId].templateItems[form.templateId] && scope.supportPlanData[form.clientId].templateItems[form.templateId] !== 'loading');
                        if ((_b = scope.supportPlanData[form.clientId].templateOriginals) === null || _b === void 0 ? void 0 : _b.filter(x => x.id === form.templateId))
                            form.supportPlanId = (_c = scope.supportPlanData[form.clientId].templateOriginals.filter(x => x.id === form.templateId)[0]) === null || _c === void 0 ? void 0 : _c.supportPlanId;
                        return !form.valid;
                    };
                };
            }
            getChildsFromTemplateItems(templateItems) {
                let result = [];
                for (const item of templateItems) {
                    const newItem = angular.copy(item);
                    delete newItem.children;
                    result.push(newItem);
                    result = result.concat(this.getChildsFromTemplateItems(item.children));
                }
                return result;
            }
            strip(html) {
                if (!html)
                    return "";
                const textEl = document.createElement("div");
                textEl.innerHTML = html;
                return textEl.textContent.trim();
            }
        };
        TagebuchSupportPlanDirective = __decorate([
            QMC.Directive('QMC.Tagebuch', 'qmJournalSupportPlan', ['$qui', 'TagebuchService', 'QmcLanguageService'])
        ], TagebuchSupportPlanDirective);
        Tagebuch.TagebuchSupportPlanDirective = TagebuchSupportPlanDirective;
    })(Tagebuch = QMC.Tagebuch || (QMC.Tagebuch = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Tagebuch;
    (function (Tagebuch) {
        let TagebuchParticipantsDirective = class TagebuchParticipantsDirective {
            constructor() {
                this.restrict = 'E';
                this.templateUrl = './journal/ParticipantsDirective';
                this.replace = true;
                this.scope = {
                    qmParticipants: '<',
                    qmList: '<'
                };
                this.link = (scope) => {
                    scope.participantsText = '';
                    const update = () => {
                        scope.participantsText = this.buildParticipantsText(scope.qmParticipants, scope.qmList);
                    };
                    // entries and the participant list are loaded by separate requests, so both may arrive in any order
                    scope.$watch('qmParticipants', update);
                    scope.$watch('qmList', update);
                };
            }
            buildParticipantsText(participants, list) {
                if (!participants || !list)
                    return '';
                const participantNames = [];
                for (const participant of participants) {
                    const listItem = list.find(x => x.value === participant.objectId);
                    if (listItem)
                        participantNames.push(listItem.text);
                }
                return participantNames.join(', ');
            }
        };
        TagebuchParticipantsDirective = __decorate([
            QMC.Directive('QMC.Tagebuch', 'qmJournalParticipants')
        ], TagebuchParticipantsDirective);
        Tagebuch.TagebuchParticipantsDirective = TagebuchParticipantsDirective;
    })(Tagebuch = QMC.Tagebuch || (QMC.Tagebuch = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Tagebuch/qmc.tagebuch.js.map
